import { createTheme } from "@mui/material";

// #f9f9f9

const theme = createTheme({
  palette: {
    primary: {
      main: "#01579b",
      light: "#9c8ca9",
      contrastText: "#fff",
    },
    secondary: {
      main: "#01579b",
      light: "#9c8ca9",
      contrastText: "#fff",
    },
    error: {
      main: "#ff4444",
    },
    background: {
      default: "#f9f9f9",
    },
    icon: "#2e5078",
    navbarBg: "#000000",
    status: "#D0D0CE",
    lightBlue: "#b9d9eb",
    doveGrey: "#737373",
    greyText: "#4A4F55",
    darkBlue: "#005078",
    silverSand: "#C1C5C8",
    snackbarBg: "#E0EAE2",
    dividerBorder: "#F5F5F5",
    disabledButton: "#7aa2b7",
    "Pending Activation": "#0074AD",
    Discovery: "#000000",
    "Pending Approval": "#0074AD",
    "SSS001": "#0074AD",
    "Rejected Sellers": "#000000",
    "On Hold": "#000000",
    Onboarding: "#20842F",
    Building: "#20842F",
    Certified: "#20842F",
  },
  typography: {
    fontFamily: `"Open Sans",  sans-serif`,
  },
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          whiteSpace: "unset",
          wordBreak: "break-word",
          color: "#000",
        },
      },
    },
    MuiAlert: {
      defaultProps: {
        components: {
          CloseButton: () => <></>,
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 280,
      stm: 600, // small to medium
      md: 768,
      mtl: 960, //medium to large
      lg: 1024,
      xl: 1536,
    },
  },
});

export default theme;
